import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from 'react';
import classNames from 'classnames';
import { Video } from './video';
import { Image } from './image';
import Play from '../icons/play';
export var VideoControl = function VideoControl(props) {
  var style = props.style,
    className = props.className,
    imageStyle = props.imageStyle,
    imageClassName = props.imageClassName,
    videoStyle = props.videoStyle,
    videoClassName = props.videoClassName,
    playBtnClassName = props.playBtnClassName,
    coverImage = props.coverImage,
    fileValue = props.fileValue;
  var _useReducer = useReducer(function () {
      return true;
    }, false),
    active = _useReducer[0],
    setActive = _useReducer[1];
  if (active) {
    return _jsx("div", Object.assign({
      style: style,
      className: classNames('relative w-full', className)
    }, {
      children: _jsx(Video, {
        className: videoClassName,
        style: videoStyle,
        autoPlay: true,
        controls: true,
        src: fileValue
      }, 'playing')
    }));
  }
  return _jsxs("div", Object.assign({
    style: style,
    className: classNames('relative w-full', className)
  }, {
    children: [_jsx(Play, {
      className: classNames('cursor-pointer absolute z-2', playBtnClassName),
      handleClick: setActive
    }), coverImage ? _jsx(Image, {
      className: imageClassName,
      style: imageStyle,
      src: coverImage
    }) : _jsx(Video, {
      className: videoClassName,
      style: videoStyle,
      src: fileValue
    }, 'static')]
  }));
};
VideoControl.defaultProps = {
  playBtnClassName: 'w-16 h-16'
};